import SectionHeader from "@/elements/Sectionheader";
import { ReviewerCardProps, ReviewerSectionProps } from "@/interfaces";
import ReviewerCard from "../ReviewerCard";
import { projectImages } from "public/Assets/Images";
import './index.scss';
import useViewType from "@/utils/Hooks/useViewType";
import Button from "@/uicomponents/Button";
const ReviewerSection = ({
  data,
  title
}: ReviewerSectionProps) => {
  const isMobile = useViewType();
  return <div className="reviewer_section" data-sentry-component="ReviewerSection" data-sentry-source-file="index.tsx">
     {title && <div className="title_wrapper">
                <SectionHeader text={title} isSeeAll={false} isTestimonial />
            </div>}
            <div className="reviwer_grid">
                {data?.slice(0, 8).map((item: any, index: number) => <div className={`reviewer_card_${index}_${item.attributes.designation}`} key={`reviewer_card_${item.id}`}>
                        <ReviewerCard name={item.attributes.name} companyName={item.attributes.companyName} designation={item.attributes.designation} reviewerImage={item.attributes.mentorImageUrl}></ReviewerCard>
                    </div>)}
            </div>
            {/* {isMobile &&  <div className="reviewer_button_wrapper" style={{
                paddingTop :"32px"
             }}>
                <Button text="See More" variant="NormalVariant" textVariant="Mobile/Body 2/M | 14 | 120" textColor="black" backgroundColor="white"
                 borderColor="black"
                 />
             </div> } */}
    </div>;
};
export default ReviewerSection;